import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIButton = _resolveComponent("UIButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b('', { variant: _ctx.variant }))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('content'))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.b('icon')),
        "aria-hidden": "true",
        innerHTML: _ctx.displayedIcons[_ctx.variant]
      }, null, 10, _hoisted_1),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('info'))
      }, [
        _createElementVNode("h3", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t(_ctx.title)), 3),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('description'))
        }, _toDisplayString(_ctx.$t(_ctx.description)), 3),
        (_ctx.tags.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.b('tags'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: tag,
                  class: _normalizeClass(_ctx.b('tag'))
                }, _toDisplayString(_ctx.$t(tag)), 3))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (_ctx.actionLabel)
      ? (_openBlock(), _createBlock(_component_UIButton, {
          key: 0,
          class: _normalizeClass(_ctx.b('action')),
          label: _ctx.actionLabel,
          view: "main",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action')))
        }, null, 8, ["class", "label"]))
      : _createCommentVNode("", true)
  ], 2))
}